import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorGraphicsCardSeries,
  fetchProcessorGraphicsCardSeriesById,
  fetchProcessorGraphicsCardSeries,
  updateProcessorGraphicsCardSeries,
  updateStatusInProcessorGraphicsCardSeries,
} from "./thunk";

interface CategoryState {
  graphics_card_series_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  graphics_card_series_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "graphics_card_series",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorGraphicsCardSeries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorGraphicsCardSeries.fulfilled, (state, action) => {
        state.loading = false;
        state.graphics_card_series_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorGraphicsCardSeries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Processor Threads";
      })
      .addCase(fetchProcessorGraphicsCardSeriesById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorGraphicsCardSeriesById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorGraphicsCardSeriesById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorGraphicsCardSeries.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.graphics_card_series_list = state.graphics_card_series_list.map((graphics_card_series) =>
          graphics_card_series.id === action.payload.id ? action.payload : graphics_card_series
        );
      })
      .addCase(addProcessorGraphicsCardSeries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateProcessorGraphicsCardSeries.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.graphics_card_series_list = state.graphics_card_series_list.map((graphics_card_series) =>
          graphics_card_series.id === action.payload.id ? action.payload : graphics_card_series
        );
      })
      .addCase(updateProcessorGraphicsCardSeries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInProcessorGraphicsCardSeries.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorGraphicsCardSeries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
